import type { WidgetSurface } from "./widgetLayout.js";

// HR-11: the athlete's own Home, one of the two widget surfaces
// (widgetLayout.ts, the engine). Home never collapses a widget: that is
// Progress's.

/** Every Home widget, in the default order (the single-column Home). */
export const HOME_WIDGET_IDS = [
  "hero",
  "readiness",
  "weeklyTargets",
  "quickWeight",
  "quickGlucose",
  "badges",
  // Off by default: Progress panels, the pain map, the measurement trends.
  "coverage",
  "e1rmTrends",
  "repsAtLoad",
  "movementBalance",
  "painVolume",
  "intensityHeatmap",
  "exerciseFrequency",
  "painMap",
  "measurements",
] as const;
export type HomeWidgetId = (typeof HOME_WIDGET_IDS)[number];

export const HOME_LAYOUT_SURFACE: WidgetSurface<HomeWidgetId> = {
  ids: HOME_WIDGET_IDS,
  // Never hidden, always first: the hero/carousel is the only place on Home
  // to start the next session, and the only place to pin the current block.
  pinned: ["hero"],
  // The inbox was the one (HR-11 d) until it left Home for the bell (#295).
  // A saved layout that still lists it resolves without it: unknown ids are
  // dropped (resolveWidgetLayout).
  unhideable: [],
  defaultHidden: [
    "coverage",
    "e1rmTrends",
    "repsAtLoad",
    "movementBalance",
    "painVolume",
    "intensityHeatmap",
    "exerciseFrequency",
    "painMap",
    "measurements",
  ],
  defaultCollapsed: [],
};
